<template>
  <div id="result" class="mb-5">
    <!--<div id="result" v-if="isResult" class=" mb-5">-->
    <p class="result-text">
      10問中
      <span id="result-seikai">{{ calc_result }}問</span>正解の
      <br class="d-sm-none" />あなたは
    </p>

    <div id="result-box">
      <img :src="image_src" alt class="img-fluid result-image" />
      <div class="result-box-content">
        <p class="font-weight-bold">{{ results_array.desc[0] }}</p>
        <p>{{ results_array.desc[1] }}</p>
        <div class="my-4 text-center scroll-wrap">
          <div class="scroll-text">
            スクロールして解説確認＆Twitterシェア！
            <span></span>
          </div>
        </div>
      </div>
    </div>

    <div class="my-5">
      <b-button @click="emitResetQuiz" class="mx-auto btn-click">
        {{ results_array.btnText }}
        <font-awesome-icon icon="undo" />
      </b-button>
    </div>
  </div>
</template>


<script>
import QuizCampaign from "./QuizCampaign";
export default {
  name: "quiz-result",
  components: {
    QuizCampaign
  },
  props: ["calc_result", "results_array"],
  computed: {
    image_src: function() {
      return "./img/result-" + this.results_array.level + ".png";
    }
  },
  methods: {
    emitResetQuiz() {
      this.$emit("reset-quiz");
    }
  }
};
</script>


<style lang="scss">
#result {
  color: #000;
  .btn-click {
    font-size: 1.1rem;
    @media (min-width: 768px) {
      font-size: 1.4rem;
    }
  }
}
.result-text {
  font-size: 1.4rem;
  font-weight: bold;
  line-height: 1.2;
  span {
    font-size: 190%;
    margin: 0 0.1em;
  }
  @media (min-width: 576px) {
    font-size: 1.6rem;
  }
  @media (min-width: 768px) {
    font-size: 1.8rem;
  }
}
#result-box {
  background: #fff;
  border-radius: 1rem;
  .result-image {
    border-radius: 1rem 1rem 0 0;
  }
  .result-box-content {
    padding: 1rem;
    text-align: left;
    font-size: 1.1rem;
    @media (min-width: 768px) {
      padding: 1rem 2rem 2rem;
    }
  }
}
.scroll-wrap {
  background: url("../static/bg_dotyellow.png") repeat 0 0;
  padding: 1.5rem;
}
.scroll-text {
  display: block;
  position: relative;
  padding-bottom: 14px;
  span {
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 24px;
    height: 24px;
    border-left: 1px solid #000;
    border-bottom: 1px solid #000;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
    -webkit-animation: sdb05 1.5s infinite;
    animation: sdb05 1.5s infinite;
    box-sizing: border-box;
  }
}
@keyframes sdb05 {
  0% {
    transform: rotate(-45deg) translate(0, 0);
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: rotate(-45deg) translate(-20px, 20px);
    opacity: 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/result.vue